import React from "react";
import Image from "@Components/Image";
import getImagePath from "@Utils/getImagePath";
import useImageWithFallback from "hooks/useImageWithFallback";
import { getVideoThumb } from "../../SectionFeatured.tsx/utils";
import styles from "../ReviewsSectionStyles.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";

interface ReviewMediaThumbnailProps {
  media: any;
  isDesktop: boolean;
  idx: number;
  handleMediaClick: (index: number, action: string) => void;
}

const ReviewMediaThumbnail: React.FC<ReviewMediaThumbnailProps> = ({
  media,
  isDesktop,
  idx,
  handleMediaClick,
}) => {
  const fallbackUrl = getImagePath(
    "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images/video_thumbnail.png",
    "thumbnail-normal",
    {},
    false,
    true,
  );

  const videoThumb =
    media?.platform === "gumlet" || media?.platform === "youtube"
      ? getVideoThumb(media, { height: 88, width: 88 })
      : media?.path;
  const resolvedThumb = useImageWithFallback(videoThumb, fallbackUrl);

  if (media.category === "videos") {
    return (
      <div
        className={styles.videoThumbnailContainer}
        onClick={() => handleMediaClick(media.index, "review_ugc_media_viewed")}
        role="none"
        key={`videoDiv${idx}`}
      >
        <Image
          className={formatClassNames(styles.topThumbnails, isDesktop && styles.desktop)}
          src={resolvedThumb || fallbackUrl}
          height={88}
          width={88}
          alt={media.caption || "Review media"}
        />
        <div className={styles.videoPlayButtonContainer}>
          <div className={styles.videoPlayButtonInner}>
            <div className={styles.videoPlayButtonTriangle} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div key={`imgs${idx}`}>
      <Image
        onClick={() => handleMediaClick(media.index, "review_ugc_media_viewed")}
        className={formatClassNames(styles.topThumbnailsImg, isDesktop && styles.desktop)}
        src={getImagePath(media?.path, "thumbnail-normal")}
        height={88}
        width={88}
        alt={media.caption || "Review media"}
      />
    </div>
  );
};

export default wrapperHOC(ReviewMediaThumbnail, {
  componentName: "ReviewMediaThumbnail-PropertyPage",
  showForChina: true,
});
